import { useState, useEffect } from 'react';
import { EQUITY, FUND, ETF, CEF, LSE, INDEX } from 'src/Api';
import Link from 'next/link';
import $ from 'jquery';
import { useRouter } from 'next/router';
import YouInvest, { CONFIGURED_SERVICE_STOCK_SUMMARIES } from 'src/Api/YouInvest';

const NO_INDEX_PATH = '/sub';

export default function SideNavigation({ quote, settings, securitySummary }) {

    const router = useRouter();
    const [showFinancials, setShowFinancials] = useState(router.pathname.includes("financials"));
    const [showFundInfo, setShowFundInfo] = useState(router.pathname.includes("fund-info"));
    const [onChartPerformanceOrOverview] = useState(router.pathname.includes("charts-performance") || !router.pathname.includes("sub"));
    const [showStockSummaries, setShowStockSummaries] = useState(false);

    useEffect(() => {
        const body = $('.sidebar-wrapper .collapsible-body');
        const menu = $('.sidebar-wrapper .local-sidebar-menu');
        const el = $('.sidebar-wrapper .collapsible-header');

        const init = () => {
            if ($(window).width() > 1000) {
                menu.addClass('active');
                body.css('display', 'block');
            } else {
                menu.removeClass('active');
                body.css('display', 'none');
            }
        }

        $(window).resize(init);

        init();

        el.click(function () {
            if (el.hasClass('active')) {
                el.removeClass('active');
                body.css('display', 'none');
            } else {
                el.addClass('active');
                body.css('display', 'block');
            }
        });

        if (
            YouInvest.getConfiguredServiceAllowed(CONFIGURED_SERVICE_STOCK_SUMMARIES, settings) && 
            securitySummary?.marketCode
        ) {
            setShowStockSummaries(true);
        }

    }, []);

    const renderLink = (action, anchorText, id, classNames, noIndex) => {
        let noIndexRoute = noIndex ? NO_INDEX_PATH : '';
        const path = action ? `${NO_INDEX_PATH}/[marketCode]${action}` : '/[marketCode]';

        return onChartPerformanceOrOverview ? <a data-testid={`${id}NavLink`} href={`/market-research${noIndexRoute}/${quote.marketCode}${action}`} style={path === router.pathname ? { fontWeight: 'bold' } : null} title={anchorText} className={`${classNames}`}>{anchorText}</a>
            : <Link href={`${noIndexRoute}/${quote.marketCode}${action}`} legacyBehavior><a data-testid={`${id}NavLink`} style={path === router.pathname ? { fontWeight: 'bold' } : null} title={anchorText} className={`${classNames}`}>{anchorText}</a></Link>
    }

    if (!quote) {
        return null;
    }

    const renderEquityNavigationItems = () => {
        return <ul>
            <li>{renderLink('', 'Overview', 'equityOverview', null, false)}</li>
            {quote.exchangeCode === LSE ? <>
                {showStockSummaries && <li>{renderLink('/summary', 'Summary', 'equitySummary', null, true)}</li>}
                <li>{renderLink('/news', 'News', 'equityNews', null, true)}</li>
            </> : null}
            <li>{renderLink('/charts-performance', 'Charts and performance', 'equityChartsPerformance', null, true)}</li>
            <li>{renderLink('/dividends', 'Dividends', 'equityDividends', null, true)}</li>
            {getFinancialsDropdown()}
            <li>{renderLink('/company-info', 'Company info', 'equityCompanyInfo', null, true)}</li>
            <li>{renderLink('/director-deals', 'Director deals', 'equityDirectorDeals', null, true)}</li>
            <li>{renderLink('/costs', 'Cost calculator', 'equityCostCalculator', null, true)}</li>
        </ul>
    }

    const renderInvestmentTrustNavigationItems = () => {
        return <ul>
            <li>{renderLink('', 'Overview', 'cefOverview', null, false)}</li>
            {quote.exchangeCode === LSE ? <>
                {showStockSummaries && <li>{renderLink('/summary', 'Summary', 'equitySummary', null, true)}</li>}
            </> : null}
            <li>{renderLink('/news', 'News', 'cefNews', null, true)}</li>
            <li>{renderLink('/charts-performance', 'Charts and performance', 'cefChartsPerformance', null, true)}</li>
            <li>{renderLink('/portfolio', 'Portfolio', 'cefPortfolio', null, true)}</li>
            <li>{renderLink('/dividends', 'Dividends', 'cefDividends', null, true)}</li>
            <li>{renderLink('/financials-and-ratios', 'Financials and ratios', 'cefFinancialsRatios', null, true)}</li>
            {getFundInfoDropdown(true)}
            <li>{renderLink('/costs', 'Cost calculator', 'cefCostCalculator', null, true)}</li>
        </ul>
    }

    const getFinancialsDropdown = () => {
        return <li>
            <Link href={`${NO_INDEX_PATH}/${quote.marketCode}/financials/summary`} legacyBehavior>
                <a data-testid="financialsDropdownLink" className={`first expanded active-trail ${(showFinancials) ? 'active' : ''}`}
                    onClick={(e) => {
                        e.preventDefault();
                        onChartPerformanceOrOverview ? window.location.pathname = `/market-research${NO_INDEX_PATH}/${quote.marketCode}/financials/summary` : router.push(`${NO_INDEX_PATH}/${quote.marketCode}/financials/summary`);

                    }} >Financials and ratios
                </a>
            </Link>

            <ul role="menu" className="ajbyi-submenu" style={{ display: ((showFinancials) ? 'block' : 'none') }}>
                <li role="presentation">
                    {renderLink('/financials/summary', 'Summary', 'financialsSummary', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/financials/income-statement', 'Income statement', 'financialsIncomeStatement', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/financials/balance-sheet', 'Balance sheet', 'financialsBalanceSheet', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/financials/cash-flow', 'Cash flow', 'financialsCashFlow', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/financials/key-ratios', 'Key ratios', 'financialsKeyRatios', 'first leaf', true)}
                </li>
            </ul>
        </li>
    }

    const getFundInfoDropdown = (isCef) => {
        return <li>
            <a data-testid="fundInfoDropdownLink" href={`/market-research${NO_INDEX_PATH}/${quote.marketCode}/${isCef ? 'fund-info/trust' : 'fund'}-info`} className={`first expanded active-trail ${(showFundInfo) ? 'active' : ''}`} rel="noreferrer">Fund info</a>
            <ul role="menu" className="ajbyi-submenu" style={{ display: ((showFundInfo || (isCef && router.pathname.includes("director-deals"))) ? 'block' : 'none') }}>
                <li role="presentation">
                    {renderLink(`/${isCef ? 'fund-info/trust' : 'fund'}-info`, 'Summary', 'fundInfoSummary', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/fund-info/target-market', 'Target market', 'fundInfoTargetMarket', 'first leaf', true)}
                </li>
                <li role="presentation">
                    {renderLink('/fund-info/documents', 'Documents', 'fundInfoDocuments', 'first leaf', true)}
                </li>
                {isCef ? <li role="presentation">
                    {renderLink('/director-deals', 'Director deals', 'fundInfoDirectorDeals', 'first leaf', true)}
                </li> : null}
            </ul>
        </li>
    }

    const renderFundNavigationItems = () => {
        return <ul>
            <li>{renderLink('', 'Overview', 'fundOverview', null, false)}</li>
            <li>{renderLink('/charts-performance', 'Charts and performance', 'fundChartsPerformance', null, true)}</li>
            <li>{renderLink('/portfolio', 'Portfolio', 'fundPortfolio', null, true)}</li>
            <li>{renderLink('/risks-and-ratings', 'Risk and rating', 'fundRiskRatings', null, true)}</li>
            {getFundInfoDropdown()}
            <li>{renderLink('/costs', 'Cost calculator', 'fundCosts', null, true)}</li>
        </ul>
    }

    const renderInstrumentSpecificNavigationItems = () => {
        switch (quote.__typename) {
            case EQUITY:
                return renderEquityNavigationItems();
            case CEF:
                return renderInvestmentTrustNavigationItems();
            case FUND:
            case ETF:
                return renderFundNavigationItems();
        }
    }

    const renderNavItems = () => {
        return <ul className="c-sidebar-nav__menu-dropdown padding-10 card-content">
            <li>{renderInstrumentSpecificNavigationItems()}</li>
        </ul>
    }

    return quote.__typename !== INDEX ? <div className="sidebar-wrapper margin-bottom-20">
        <ul className="collapsible-sidenav" data-collapsible="accordion">
            <li className="active">
                <div className="collapsible-header local-sidebar-menu darkblue-500-bg white-text active">
                    <i className="fa fa-bars margin-bottom-0 margin-right-0 h6" aria-hidden="true"></i> Menu
                </div>
                <div className="collapsible-body">
                    <div className="c-sidebar-nav">
                        <ul className="c-sidebar-nav__list">
                            <li className="c-sidebar-nav__item expanded white-bg will-change card margin-top-0 margin-bottom-0">
                                {renderNavItems()}
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
        </ul>
    </div> : null

}
